// SessionExpiredModal.tsx
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { SessionStorage } from '../../../services/storage';
import { useUserContextHook } from "../../../hooks/useUserContextHook";
import { useTableStore } from "../../../stores/TableFilterStore";

const SessionExpiredModal = () => {
    const [countdown, setCountdown] = useState(5);
    const location = useLocation();
    const navigate = useNavigate();
    const { clearDetailHandle } = useUserContextHook();
    const { clearAll } = useTableStore();

    const onSignOut = useCallback(() => {
        clearDetailHandle?.();
        navigate('/', { replace: true, state: { from: location } });
        SessionStorage.clear();
        // localStorage.clear();
        clearAll();
    }, [clearAll, clearDetailHandle, location, navigate])

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((c) => c - 1);
        }, 1000);

        const timeout = setTimeout(() => {
            onSignOut();
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: "100vw",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: 30,
                    borderRadius: 10,
                    textAlign: "center",
                    maxWidth: 400,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
            >
                <h2>Session Expired</h2>
                <p>You will be logged out in {countdown} seconds.</p>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
